import * as yup from "yup";

// Validation for the CDM partner landing page's lead-generation enquiry
// form (see ../../app/(partners)/partners/cdm/sections/CdmLeadForm.tsx).
//
// Deliberately separate from ContactUsSchema: that schema's visible fields
// (name/email/phone/subject/message) belong to the site-wide ContactForm.
// This form collects a different, structured set of answers (services
// wanted, travel dates, party size, notes) and composes `subject`/
// `message` itself before dispatching the same `contactUs` action — so
// this schema validates what the visitor actually sees, not the payload
// shape the API expects.
export const cdmLeadFormSchema = yup.object().shape({
  name: yup.string().trim().required("Name is required"),
  email: yup.string().email("Enter a valid email address").required("Email is required"),
  phone_number: yup.string().required("Phone number is required"),
  phone_code: yup.string().nullable(),
  services: yup
    .array()
    .of(yup.string().required())
    .min(1, "Select at least one service you're interested in")
    .required("Select at least one service you're interested in"),
  check_in: yup.string().required("Check-in date is required"),
  check_out: yup
    .string()
    .required("Check-out date is required")
    .test(
      "after-check-in",
      "Check-out must be on or after check-in",
      function (checkOut) {
        const { check_in: checkIn } = this.parent;
        if (!checkIn || !checkOut) return true;
        return new Date(checkOut) >= new Date(checkIn);
      }
    ),
  travelers: yup
    .number()
    .typeError("Enter a number of travellers")
    .integer("Enter a whole number")
    .min(1, "At least one traveller is required")
    .required("Number of travellers is required"),
  notes: yup.string().trim(),
});

export type CdmLeadFormValues = yup.InferType<typeof cdmLeadFormSchema>;
